export default __webpack_public_path__ + "static/SubpageBanners_MeetDrCollins-0e595701a72b5e43536b7619be1d7e06.jpg";